import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  formPacks: [],
  formPack: {
    dealer_id: null,
  },
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.FORMPACKS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('formPacks', payload);
    case types.FORMPACK_SUCCESS: {
      const forms = payload.FormTemplates.map((f) => f.id);
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('formPack', { ...payload, forms });
    }
    case types.CREATE_FORMPACK_SUCCESS:
    case types.UPDATE_FORMPACK_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('formPack', payload);
    case types.DELETE_FORMPACK_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('formPacks', remove({ id: payload })(state.formPacks));
    case types.FORMPACKS_REQUEST:
    case types.FORMPACK_REQUEST:
    case types.CREATE_FORMPACK_REQUEST:
    case types.UPDATE_FORMPACK_REQUEST:
    case types.DELETE_FORMPACK_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.FORMPACKS_FAILURE:
    case types.FORMPACK_FAILURE:
    case types.CREATE_FORMPACK_FAILURE:
    case types.UPDATE_FORMPACK_FAILURE:
    case types.DELETE_FORMPACK_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_FORMPACK:
      return state.set('formPack', {
        ...requestReducerState().formPack,
        dealer_id: action.payload,
      });
    default:
      return state;
  }
};
